<template>
    <div>
     <b-modal size="xl" :id="ModalId" 
      @shown="prepararDrag"
       :modal-class="'is-draggable'"
     :visible="true" centered no-close-on-backdrop no-close-on-esc :title="TitleWindow"
      ref="modalEditGoals" @close="this.emitEventCancel" @ok="this.emitEventOK" 
      :ok-title="$t('Shared.Save')"  @cancel="this.emitEventCancel" :cancel-title="$t('Shared.BtnCancel')"> 
        <b-row v-if="VisibleIntvWiley">
          <b-col lg="12" md="12" sm="12">     
            <MdTitle v-bind:Text="$t('modalAddIntervention.intervention')" v-bind:isSubtitle="true" v-bind:Name="'Intervention'" class="subtitleWizard"/>
              <MdCheckListBox2 
                  v-model="InterventionModel"
                  v-bind:Options="InterventionsList"   
                  v-bind:Height="'150px'"         
                  v-bind:OnChangeProp="OnChangeIntervention"
                  v-bind:columnCount="1"
                  :textField="'description'"
                  :valueField="'code'"/> 
          </b-col>
        </b-row>  

        <MdTitle v-bind:Text="$t('modalAddGoal.other')" v-bind:isSubtitle="true" v-bind:Name="'Other'"/> 
        <b-row>            
          <b-col md="12">             
              <MdMemo v-bind:Name="'interventiondescription'" v-bind:Rows="'4'" v-bind:UseDinamicClass="false"
                          v-bind:DynamicClass="'modalTextarea'" v-bind:MaxRows="'6'"
                          v-model="intdescriptionBlank" />
          </b-col>
         </b-row> 
     </b-modal>  
    </div>
</template>
 
 <script>
 //import Utils from '@/common/utils'
 import ShowMessage from '@/components/messages/ShowMessage.js'
 import TreatmentPlan from '@/services/treatmentplan.service'
 

 export default {
   name: 'ModalAddIntervention',
   mixins: [ShowMessage],  
   props: {
     ModalId: String,
     TitleWindow: String,
     ProblemRecId:String,
     groupId:Number,
     headerId:String,
     probCode:String,
     GoalListObj:Array,
     ObjectiveListObj:Array,
     GoalRecId:String,
     ObjRecId:String
   },
   
   data(){
     return {
        VisibleIntvWiley:false,
        intdescriptionBlank:"",
        InterventionsList:[],
        InterventionModel:[],
        IntvData:[],
     }
   },
 
   methods:{
     prepararDrag() {
  this.$nextTick(() => {
    const outer = document.getElementById(`${this.ModalId}___BV_modal_outer_`);
    if (!outer) {
      console.warn("No se encontró el contenedor del modal");
      return;
    }

    const dialog = outer.querySelector(".modal-dialog");
    const header = outer.querySelector(".modal-header");

    if (!dialog || !header) {
      console.warn("No se encontró header o dialog");
      return;
    }

    if (outer.classList.contains("is-draggable")) 
            return;

    header.style.cursor = "move";

    header.onmousedown = (e) => {
      e.preventDefault();

      // Obtener posición actual antes de tocar estilos
      const rect = dialog.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      // Fijar posición actual (solo en el primer movimiento)
      dialog.style.width = `${rect.width}px`;
      dialog.style.height = `${rect.height}px`;
      dialog.style.position = "fixed";
      dialog.style.left = `${rect.left}px`;
      dialog.style.top = `${rect.top}px`;
      dialog.style.margin = 0;
      dialog.style.transform = "none";

      const moveHandler = (eMove) => {
        dialog.style.left = `${eMove.clientX - offsetX}px`;
        dialog.style.top = `${eMove.clientY - offsetY}px`;
      };

      document.addEventListener("mousemove", moveHandler);
      document.addEventListener(
        "mouseup",
        () => document.removeEventListener("mousemove", moveHandler),
        { once: true }
      );
    };
  });
},
     emitEventOK(/*bvModalEvent*/){     
        this.AddIntervention();
     },     

     OnChangeGoals(){

     },

     getDescrByCode(code){
        let result = {desc:"",isEvidencebased:false};
        for(var i = 0; i < this.InterventionsList.length; i++){
           if(this.InterventionsList[i].code === code){           
            result.desc = this.InterventionsList[i].description;
            result.isEvidencebased = this.InterventionsList[i].isEvidenceBased;
            break;
           }
        }
        return result;
     },

     PrepareData(){
            this.IntvData = [];         
            for(var i = 0; i < this.InterventionModel.length; i++){
                let result = this.getDescrByCode(this.InterventionModel[i]);
                this.IntvData.push(
                    {                       
                      intCode:this.InterventionModel[i].toString(),
                      intDesc:result.desc,
                      isEvidenceBased:result.isEvidencebased
                    }
                    );
            }

            if(this.intdescriptionBlank.length > 0){
                this.IntvData.push(
                    {                       
                      intCode:"0",
                      intDesc:this.intdescriptionBlank,
                      isEvidenceBased:false
                    }
                    );
            }
        },


        AddIntervention(){        
        this.PrepareData();
        if(this.IntvData.length > 0){
            var objdata = {
              admissionId:this.$route.params.recordid,
              probRecId:this.ProblemRecId.toString(),
              goalRecId:this.GoalRecId,
              objRecId:this.ObjRecId,
              interventions:this.IntvData
            };
         TreatmentPlan.AddIntervention(objdata)
            .then((response) => { 
               if(response.data){
                this.$emit('RefreshGetTP');
                setTimeout(() => 
                        this.$bvToast.toast(this.$t('treatmentplan.InterventionSaved'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
                        , 5); 
               }             
            })
            .catch((error) => {
                if (!error.response) {
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.NotAbleToUpdate'),"error");
                }     
                   else if(error.response.status === 400 ){
                     this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }   
                     else if(error.response.status === 500){
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.ThereWereSomeError'),"error");
                     } else{
                         this.showMessage(this.$tc('Msg.Error'),error.response.data.errorMessage,"error");
                     }    
            });
        }
    },

     OnChangeIntervention(){

     },

     async getMedezTxInterventionsList() {           
            this.$emit('load', true);
            var parameter = {
                GroupId: this.groupId,
                ProblemCode: this.probCode,
                GoalCodeList:this.GoalListObj,
                ObjectiveCodeList: this.ObjectiveListObj,
                ExcludeWithHeaderId:this.headerId,
                IsWizard:false
            };
           await TreatmentPlan.getMedTxInterventions(parameter)
                .then((response) => {
                if (response.status == '200' && response.data) {
                    if(response.data.length > 0 && response.data[0].objectives.length > 0){
                      if(Array.isArray(response.data[0].objectives[0].interventions)){
                        this.InterventionsList = response.data[0].objectives[0].interventions;
                      }else{
                        this.InterventionsList = [];
                      }
                    }else{
                      this.InterventionsList = [];
                    }
                    
                    this.VisibleIntvWiley = this.InterventionsList.length > 0 ? true : false;
                }
                this.$emit('load', false);
            })
                .catch(error => {
                this.$emit('load', false);
                if (!error.response) {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.retrieveInfo'), "error");
                }
                else if (error.response.status === 400) {
                    this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                }
                else if (error.response.status === 500) {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.ThereWereSomeError'), "error");
                }
                else {
                    this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                }
            });
        },


     emitEventCancel(){
      this.$emit('ModalTPAddIntervention');
    },    
   },
 
   async mounted(){
    await this.getMedezTxInterventionsList();
   },
 };
 </script>
 <style>


.modal-dialog {
  transition: none !important;
  transform: none !important;
}

.modal-dialog.dragging {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  opacity: 0.98;
  cursor: grabbing !important;
  transition: box-shadow 0.2s ease;
}
.modal-header {
  user-select: none; /* evita seleccionar texto al arrastrar */
}
</style>